<template>
    <modal id="field-inspection-payment-modal">
        <template slot="body">
            <div class="information">
                The Cost of the Field Inspection is $500.00
            </div>
            <payment-form @success="save" @error="onError"></payment-form>
        </template>
        <template slot="footer">
            <button class="btn btn-dafault" @click="closeModal('field-inspection-payment-modal')">
                Cancel
            </button>
            <div>
                <button class="btn btn-danger" @click="markAsPaid()" :disabled="noPaymentForm.isSubmitted || form.isSubmitted " v-if="authorize('admin')">
                    <span v-if="!noPaymentForm.isSubmitted">Mark As Paid</span>
                    <span v-else><i class="fa fa-spin fa-spinner"></i> Processing...</span>
                </button>
                <button class="btn btn-success" @click="checkout()" :disabled="form.isSubmitted || noPaymentForm.isSubmitted">
                    <span v-if="!form.isSubmitted">Complete Payment</span>
                    <span v-else><i class="fa fa-spin fa-spinner"></i> Processing...</span>
                </button>
            </div>
        </template>
    </modal>
</template>
<script>
export default {

    props: {
        value: {
            type: Object,
            required: true,
        },
        intent:{
            required: true
        }
    },

    data() {
        return {
            field_inspection: this.value,
            form: new Form({}, false),
            noPaymentForm: new Form({
                paid_at: moment().format('Y-MM-DD H:mm:ss'),
                timezone: clientTimeZone,
            }, false),
            defaultCard: null,
        }
    },

    methods:{

        save() {
            this.form.post(`/field-inspections/${this.field_inspection.number}/checkout`).then(response => {
                this.closeModal('field-inspection-payment-modal');
                this.$emit('input', response);
                Alert.withAction(`Payment Completed`).then(() => {
                    this.refreshPage();
                })
            })
        },

        onError(message){
            Alert.error(message)
            this.form.isSubmitted = false;
        },

        markAsPaid(){
            this.noPaymentForm.patch(`/field-inspections/${this.field_inspection.number}`).then(response => {
                this.closeModal('field-inspection-payment-modal');
                this.refreshPage();
            });
        },

        checkout(){
            this.form.isSubmitted = true;
            App.bus.$emit('checkout-form', {secret: this.intent});
        }
    },

    watch:{
        value(val){
            this.field_inspection = val;
        }
    },
}
</script>
